/**
 * Vista por seccion (Ares #30819; diseno de Atenea MADERINCO-PRODUCTO-SECCION-PASO-T1, aceptado #30377): el dueno ve los
 * productos de UNA seccion de la plantilla agrupados por paso y los reordena dentro de su paso (mas facil que ir producto
 * por producto en Editar producto).
 *
 * Contrato (nexo-api 568, main): GET /presupuestos/plantilla/secciones/{seccionId}/productos ->
 *   {seccionId, seccion, productos[{productoId, nombre, unidad, precioVenta, activo, paso, orden, pregunta}]}
 * El orden se escribe con PUT /productos/{id}/ubicaciones (campo orden de la ubicacion de ESA seccion, con la revision).
 * Sin DOM: lo prueba check-vista-por-seccion.
 *
 * @module application/presupuestos/vistaPorSeccion
 */
import { PASOS } from './ubicacionesProducto.js';

const de = (o, k) => (o ? (o[k] ?? o[k[0].toUpperCase() + k.slice(1)]) : undefined);
const num = (v) => (v === null || v === undefined || v === '' || !Number.isFinite(Number(v)) ? null : Number(v));

/** La respuesta en grupos por paso (en el orden 1, 2, 3), cada uno por orden y despues por nombre. */
export function leerSeccionProductos(data) {
  const d = data?.data ?? data ?? {};
  const productos = (de(d, 'productos') || []).map((p) => ({
    productoId: String(de(p, 'productoId') ?? ''), nombre: String(de(p, 'nombre') ?? ''), unidad: de(p, 'unidad') ?? null,
    precioVenta: num(de(p, 'precioVenta')), activo: de(p, 'activo') !== false, paso: String(de(p, 'paso') ?? ''),
    orden: num(de(p, 'orden')), pregunta: de(p, 'pregunta') ?? null
  }));
  const orden = (a, b) => (a.orden ?? Infinity) - (b.orden ?? Infinity) || a.nombre.localeCompare(b.nombre, 'es');
  const grupos = PASOS.map((p) => ({ paso: p.id, etiqueta: p.etiqueta, productos: productos.filter((x) => x.paso === p.id).sort(orden) }));
  const otros = productos.filter((x) => !PASOS.some((p) => p.id === x.paso));
  if (otros.length) grupos.push({ paso: 'otro', etiqueta: 'Sin paso reconocido', productos: otros.sort(orden) });
  return { seccionId: String(de(d, 'seccionId') ?? ''), seccion: String(de(d, 'seccion') ?? ''), total: productos.length, grupos };
}

/**
 * Subir (-1) o bajar (+1) un producto dentro de su paso. Devuelve los productos cuyo orden CAMBIA, con su orden nuevo
 * (1..n en el grupo, para que el resultado sea el mismo que se ve). Vacio si el movimiento no es posible.
 * @returns {Array<{productoId:string, orden:number}>}
 */
export function moverEnPaso(grupo, indice, direccion) {
  const lista = [...(grupo?.productos || [])];
  const destino = indice + direccion;
  if (indice < 0 || indice >= lista.length || destino < 0 || destino >= lista.length) return [];
  [lista[indice], lista[destino]] = [lista[destino], lista[indice]];
  return lista.map((p, i) => ({ productoId: p.productoId, orden: i + 1, antes: p.orden }))
    .filter((x) => x.antes !== x.orden).map(({ productoId, orden }) => ({ productoId, orden }));
}

/** Las ubicaciones de un producto con el orden nuevo en ESA seccion (el resto igual), listas para el PUT. */
export function conOrdenEnSeccion(ubicaciones, seccionId, orden) {
  return (ubicaciones || []).map((u) => ({ seccionId: u.seccionId, paso: u.paso, orden: u.seccionId === seccionId ? orden : (u.orden ?? null), pregunta: u.pregunta ?? null }));
}
